import React, { Component } from "react"
import { Switch, Route, Redirect } from "react-router"

//import Dashboard from "./modules/Dashboard"
import Cadastro from "./modules/seguranca/usuarios/Cadastro"
import Stock from "./modules/relatorios/stock/stock"
import Price from "./modules/relatorios/price/price"
import CustGprPcg from "./modules/relatorios/custGrpPcg/custGrpPcg"
import CustPrdLst from "./modules/relatorios/custPrdLst/custPrdLst"
import PrdCmb from "./modules/relatorios/prdCmb/prdCmb"
import Customer from "./modules/relatorios/customer/customer"
import Order from "./modules/relatorios/order/order"
//import CadastroModal from "./modules/seguranca/usuarios/CadastroModal"

class Routes extends Component {
    constructor(props) {
         super(props)
         this.state = { tiraroerrocompilacao: 0 }
         
    }

    render() {
        return (
            <Switch>
                {/* <Route exact path="/" component={Dashboard} /> */}
                <Route path="/cadastro" component={Cadastro} />
                <Route path="/stock" component={Stock} />
                <Route path="/price" component={Price} />
                <Route path="/custGprPcg" component={CustGprPcg} />
                <Route path="/custPrdLst" component={CustPrdLst} />
                <Route path="/prdCmb" component={PrdCmb} />
                <Route path="/customer" component={Customer} />
                <Route path="/order" component={Order} />
                {/* <Route path="/cadastroModal" component={CadastroModal} />  */}
                <Redirect from="*" to="/" />
            </Switch>
        )
    }
}

export default Routes